var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMediaGenerationV1GeneratedImage from '@wix/ambassador-media-generation-v1-generated-image/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var RequestSource;
(function (RequestSource) {
    RequestSource["UNDEFINED"] = "UNDEFINED";
    RequestSource["STORES"] = "STORES";
    RequestSource["PHOTO_STUDIO"] = "PHOTO_STUDIO";
    RequestSource["MEDIA_MANAGER"] = "MEDIA_MANAGER";
    RequestSource["MOBILE_BRANDED_APPS"] = "MOBILE_BRANDED_APPS";
    RequestSource["FUNNEL_RESTAURANTS_MENU"] = "FUNNEL_RESTAURANTS_MENU";
    RequestSource["FUNNEL_STORES"] = "FUNNEL_STORES";
    RequestSource["FUNNEL_BLOG"] = "FUNNEL_BLOG";
    RequestSource["FUNNEL_BOOKINGS"] = "FUNNEL_BOOKINGS";
    RequestSource["FUNNEL_EVENTS"] = "FUNNEL_EVENTS";
    RequestSource["FUNNEL_ONLINE_PROGRAMS"] = "FUNNEL_ONLINE_PROGRAMS";
    RequestSource["FUNNEL_PORTFOLIO"] = "FUNNEL_PORTFOLIO";
    RequestSource["FUNNEL_PRICING_PLANS"] = "FUNNEL_PRICING_PLANS";
    RequestSource["MEDIA_MANAGER_MOBILE"] = "MEDIA_MANAGER_MOBILE";
    RequestSource["SITE_GENERATOR"] = "SITE_GENERATOR";
})(RequestSource || (RequestSource = {}));
export var ProductFeature;
(function (ProductFeature) {
    ProductFeature["UNDEFINED_PRODUCT_FEATURE"] = "UNDEFINED_PRODUCT_FEATURE";
    ProductFeature["REGENERATION"] = "REGENERATION";
})(ProductFeature || (ProductFeature = {}));
const _configurationRequest = {};
const _configurationResponse = {};
const _generateImageRequest = {};
const _generateImageResponse = {};
const _resetQuotaRequest = {};
const _resetQuotaResponse = {};
const _setUserQuotaRequest = {};
const _setUserQuotaResponse = {};
/**
 * Generate images according to the specified prompt
 * Due to provider limitations, we may need to switch between providers.
 * This means that the result size of the image (width and height) may not be the same as the requested size
 * This method will always try to find the closest size that the AI provider allows
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 * @deprecated
 * @targetRemovalDate 2024-11-01
 */
export function generateImage(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            textPrompt: '$[0].textPrompt',
            style: '$[0].style',
            width: '$[0].width',
            height: '$[0].height',
            requestSource: '$[0].requestSource',
            negativePrompt: '$[0].negativePrompt',
            productFeature: '$[0].productFeature',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateImageRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateImageResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#variations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaGenerationV1GeneratedImage.generateImage(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Return service level configurations to the client for dropdown fields content
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function configuration() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _configurationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _configurationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixMediaGenerationV1GeneratedImage.configuration(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Return quota record for a site
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function setUserQuota(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { quota: '$[0].quota', userId: '$[0].userId' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _setUserQuotaRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _setUserQuotaResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaGenerationV1GeneratedImage.setUserQuota(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * only allowed for specific users, resets the quota for all users
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function resetQuota() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _resetQuotaRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _resetQuotaResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixMediaGenerationV1GeneratedImage.resetQuota(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=media-generation-v1-generated-image.universal.js.map